'use strict';
define([], function () {
    function Controller($scope, $mdDialog, metricGroups, defaultColumns, selectedColumns) {
        var vm = $scope;
        vm.metricGroups = metricGroups;
        vm.selectedColumns = clone(selectedColumns);
        vm.setAll = setAll;
        vm.reset = reset;
        vm.cancel = cancel;
        vm.apply = apply;

        function setAll() {
            Object.keys(vm.selectedColumns).forEach(function (key) {
                vm.selectedColumns[key] = true;
            });
        }

        function reset() {
            vm.selectedColumns = clone(defaultColumns);
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function apply() {
            $mdDialog.hide(vm.selectedColumns);
        }

        function clone(value) {
            return JSON.parse(JSON.stringify(value || {}));
        }
    }

    Controller.$inject = [
        '$scope',
        '$mdDialog',
        'metricGroups',
        'defaultColumns',
        'selectedColumns'
    ];

    return Controller;
});
